import styled from 'styled-components';

/**
 * Shared desktop sidebar used by the client and artisan two-column pages.
 *
 * The whole sidebar stays attached below the desktop header while the main
 * column continues to scroll. Long profile cards get their own small internal
 * scrollbar instead of pushing actions outside the viewport.
 */
const StickySidebar = styled.aside`
  min-width: 0;
  align-self: start;
  position: sticky;
  top: 5.7rem;
  z-index: 2;

  max-height: calc(100dvh - 6.5rem);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
  padding-bottom: 0.25rem;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(17, 17, 17, 0.2);
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  @supports not (height: 100dvh) {
    max-height: calc(100vh - 6.5rem);
  }

  /* These pages already become single-column on compact laptops and tablets. */
  @media (max-width: 74rem) {
    display: none;
    position: static;
    max-height: none;
    overflow: visible;
  }
`;

export default StickySidebar;
